import { useModalForm } from '@/shared/hooks/useModalForm';
import { inspectionService } from '@/services/inspection.service';
import { ScheduleInspectionPayload, TimeSlot } from '@/services/types/inspection.types';

export interface ScheduleFormData {
  scheduleDate: string;
  timeSlot: string;
  notes?: string | undefined;
}

interface UseScheduleInspectionModalProps {
  itemId: string;
  onClose: () => void;
  onSuccess: () => void;
}

export function useScheduleInspectionModal({
  itemId,
  onClose,
  onSuccess,
}: UseScheduleInspectionModalProps) {
  const { form, isSubmitting, handleFormSubmit } = useModalForm<ScheduleFormData>({
    onSubmit: async (values) => {
      const [day, month, year] = values.scheduleDate.split('/');
      const formattedDate = `${year}-${month}-${day}`;

      const payload: ScheduleInspectionPayload = {
        scheduleDate: formattedDate,
        timeSlot: Number(values.timeSlot) as TimeSlot,
        ...(values.notes && { notes: values.notes }),
      };

      await inspectionService.scheduleInspectionItem(itemId, payload);
    },
    onClose,
    onSuccess,
    successMessage: 'Inspeção agendada com sucesso!',
    errorMessage: 'Erro ao agendar inspeção',
  });

  return {
    form,
    isSubmitting,
    handleFormSubmit,
  };
}
